import { render } from "./Analytics.vue?vue&type=template&id=5214a136"
import script from "./Analytics.vue?vue&type=script&lang=js"
export * from "./Analytics.vue?vue&type=script&lang=js"

import "./Analytics.vue?vue&type=style&index=0&id=5214a136&lang=css"

import exportComponent from "/Users/jonathanhuttmann/Downloads/lb-dm-nachhaltigkeitspreis-2024/lbdmnp24-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__